// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import { Button } from 'moods-react/Button';
import HelpTileComponent from './tile/HelpTileComponent';
import ContactComponent from './contact/ContactComponent';
import messages from '../../data/help';
import ContactImage from '../assets/help/ContactIcon';
import FaqImage from '../assets/help/FaqIcon';
import { faqExists } from '../services/faq/FaqService';
import AnalyticsClient from '../../clients/AnalyticsClient';
import faqEvents from '../../analytics/events/faqs';

import './HelpPage.scss';

class HelpPageComponent extends React.Component {
  mapTypeToMessage(type: string) {
    const typeToMessageMap = {
      accountManager: messages.helpPageContactAccountManager,
      primaryContact: messages.helpPageContactAdmin,
      customerService: messages.helpPageContactCustomerService,
    };
    if (Object.hasOwnProperty.call(typeToMessageMap, type)) {
      return typeToMessageMap[type];
    }
    return messages.helpPageContactDefault;
  }

  render() {
    const { config, actions } = this.props;
    const { intl } = this.context;
    const messageType = this.mapTypeToMessage(config.contacts.toPopulateProductPage.type);

    const openFaq = () => {
      actions.openFaq({ message: intl.formatMessage(messages.helpPagePopUpError) });
      AnalyticsClient.trackEvent(faqEvents.openFaq());
    };

    const emailFaq = () => {
      this.props.actions.emailFaq();
      AnalyticsClient.trackEvent(faqEvents.emailFaq());
    };

    return (
      <div className="help-page">
        <header>
          <h1 className="u-fontFamily-secondary">
            <FormattedMessage {...messages.helpPageTitle} />
          </h1>
        </header>
        <section className="help-page__body u-display-flex">
          {faqExists() && (
            <HelpTileComponent>
              <div className="help-tile__image">
                <FaqImage />
              </div>
              <header className="help-tile__title">
                <FormattedMessage {...messages.helpPageFaqTitle} />
              </header>
              <p>
                <FormattedMessage {...messages.helpPageFaqDescription} />
              </p>
              <Button onClick={openFaq}>{intl.formatMessage(messages.helpPageFaqButton)}</Button>
            </HelpTileComponent>
          )}
          <HelpTileComponent>
            <div className="help-tile__image">
              <ContactImage />
            </div>
            <header className="help-tile__title">
              <FormattedMessage {...messages.helpPageContactTitle} />
            </header>
            <p>
              <FormattedMessage {...messageType} />
            </p>
            <ContactComponent {...config.contacts.toPopulateProductPage} onClick={emailFaq} />
          </HelpTileComponent>
        </section>
      </div>
    );
  }
}

HelpPageComponent.propTypes = {
  config: PropTypes.any,
  actions: PropTypes.shape({
    openFaq: PropTypes.func.isRequired,
    emailFaq: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    // This is how you get the location from the router
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

HelpPageComponent.contextTypes = {
  intl: intlShape.isRequired,
};

HelpPageComponent.displayName = 'HelpPage';

export default HelpPageComponent;
